<template>
  <v-badge :value="selectedOptions.length > 0" :content="selectedOptions.length" overlap color="marca-0-l40">
    <v-select
      ref="vSelect"
      v-model="selectedOptions"
      class="select-options-filter"
      dense
      :label="label"
      outlined
      :items="options"
      :menu-props="{ maxHeight: '400px', offsetY: true }"
      multiple
      hide-details
      append-icon="expand_more"
      :item-text="itemText"
      :item-value="itemValue"
      :return-object="returnObject"
      @blur="change"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index === 0 && selectedOptions.length === 1" class="selected-text no-wrap">{{ item.text ? item.text : item.name }}</span>
        <span v-if="index === 0 && selectedOptions.length > 1" class="selected-text">{{ selectedOptions.length }} selecionados</span>
      </template>
    </v-select>
  </v-badge>
</template>

<script>
export default {
  name: 'SelectOptionsFilter',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    itemText: {
      type: String,
      default: 'text',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedOptions: [],
  }),
  watch: {
    value(newValue, oldValue) {
      this.selectedOptions = this.value
    },
  },
  mounted() {
    this.selectedOptions = this.value
  },
  methods: {
    clear() {
      this.selectedOptions = []
      this.change()
      this.$refs.vSelect.blur()
    },
    onClick() {
      this.change()
      this.$refs.vSelect.blur()
    },
    change() {
      this.$emit('change', this.selectedOptions)
    },
  },
}
</script>

<style lang="scss" scoped>
.no-wrap {
  white-space: nowrap;
}

.select-options-filter {
  border-radius: 8px;
  width: 180px;
  margin-top: -2px;
  max-width: 220px;
  color: $marca-0-l10;

  .selected-text {
    color: $marca-0-l10;
    font-size: 14px;
  }

  ::v-deep .v-label {
    color: $marca-0-l10;
    font-size: 14px;
  }

  ::v-deep fieldset {
    border-color: $marca-0-l10;
  }

  ::v-deep .v-icon {
    color: $marca-0-l10;
  }
}
</style>
